import React from 'react'
function DiscountProgressBar(props) {
    return (
        <div className={`animated-progress ${props.type == "mobile" ? 'mobileProgress' : "desktopProgress"}`}>
            <span style={{width : `${props.amount}`}}></span>
        </div>
    )
}
export default DiscountProgressBar